export default [
    {
        name: "APP_LOGIN",
        callback: function (auth) {
            this.$store
                .dispatch("auth/signIn", auth)
                .then(() => {
                    // this.$store.commit("setLoading", true);
                    // return this.$store.dispatch("database/load").finally(() => {
                    //     this.$store.commit("setLoading", false);
                    // });
                })
                .then(() => {

                    this.$router.push({name: "home"}).catch(error => {
                        console.info(error.message);
                    })
                    this.notification("green", "Login successfully.");
                    return Promise.resolve();
                })
                .catch(error => {
                    this.notification("red", "Login failed.");
                    console.log("login failed:", error);
                });
        }
    },
    {
        name: "APP_LOGOUT",
        callback: function () {
            this.$store
                .dispatch("auth/signOut")
                .then(() => {
                    return this.$store.dispatch("database/clear");
                })
                .then(() => {
                    this.$router.push({name: "login"}).catch(error => {
                        console.info(error.message);
                    })
                    this.notification("green", "Logout successfully.");
                })
                .catch(error => {
                    console.error("Logout: ", error);
                    this.notification("red", "Logout failed.");
                });
        }
    },
    {
        name: "APP_FULLSCREEN",
        callback: function () {
            let doc = window.document;
            let docEl = doc.documentElement;

            let requestFullScreen =
                docEl.requestFullscreen ||
                docEl.mozRequestFullScreen ||
                docEl.webkitRequestFullScreen ||
                docEl.msRequestFullscreen;
            let cancelFullScreen =
                doc.exitFullscreen ||
                doc.mozCancelFullScreen ||
                doc.webkitExitFullscreen ||
                doc.msExitFullscreen;

            if (
                !doc.fullscreenElement &&
                !doc.mozFullScreenElement &&
                !doc.webkitFullscreenElement &&
                !doc.msFullscreenElement
            ) {
                requestFullScreen.call(docEl);
            } else {
                cancelFullScreen.call(doc);
            }
        }
    }
];
